import React from 'react';
import './ChevronProcessDiagram.scss';
import { TimelineClosingDate } from '../../../slices/marketplace/closing-date/models/timeline-closing-date.model';
import { formatBusinessDatePt } from '../../../slices/marketplace/timeline/utils/timeline-dates';

interface ChevronDiagramClosingDateTileProps {
    closingDate: TimelineClosingDate;
}

export const ChevronDiagramClosingDateTile = (
    props: ChevronDiagramClosingDateTileProps
) => {
    return (
        <div className="column-item closing-date-tile">
            <div className="event-name">Closing Date</div>
            <div className="start-date">
                Date: {formatBusinessDatePt(props.closingDate.date)}
            </div>
            <div className="deadline">
                {props.closingDate.isAgreed
                    ? 'Agreed'
                    : 'Default: LOI exclusivity end'}
            </div>
        </div>
    );
};
